import { render, staticRenderFns } from "./ModalButtons.vue?vue&type=template&id=3cc89f69&"
import script from "./ModalButtons.vue?vue&type=script&lang=js&"
export * from "./ModalButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports